import { Page } from '~/components/Page'
import { BackToTop } from '~/components/ui'
import { CategoryTabs } from '../components/CategoryTabs'
import { InventoryControls } from '../components/InventoryControls'
import { InventoryGrid } from '../components/InventoryGrid'
import { PointsSummary } from '../components/PointsSummary'
import { RateReference } from '../components/RateReference'
import { StakeListProvider } from '../providers/StakeListProvider'
import { UserStakeProvider } from '../providers/UserStakeProvider'

export const StakeRoute = () => {
    return (
        <Page title='Inventory'>
            <UserStakeProvider>
                <Inventory />
            </UserStakeProvider>
        </Page>
    )
}

/**
 * Five bands, each with exactly one job: say what the page is, say what it has earned, choose a
 * category, narrow the list, show the items.
 */
const Inventory = () => {
    return (
        <div className='max-w-[var(--page-max-width)] mx-auto flex flex-col gap-4 md:gap-8 px-4 md:px-8 py-5 md:py-12'>
            <Hero />
            <PointsSummary />
            <StakeListProvider>
                <CategoryTabs />
                <InventoryControls />
                <InventoryGrid />
            </StakeListProvider>
            <BackToTop />
        </div>
    )
}

const Hero = () => {
    return (
        <div className='flex flex-col gap-3 md:gap-4'>
            {/* The mobile menu bar already renders "INVENTORY" as the page header, so the visible
                h1 is a duplicate there. Kept in the accessibility tree at every width. */}
            <h1 className='sr-only md:not-sr-only text-3xl md:text-6xl font-black uppercase select-none'>
                My Inventory
            </h1>
            <p className='text-white/60 text-sm md:text-lg font-semibold'>
                Activate your Operatives and Weapon Skins to earn BR1 Points.
            </p>
            <RateReference />
        </div>
    )
}
